jQuery(document).ready(function($){
	$('.add_to_cart_button').each(function(){
		$(this).append(' <span class="spinner-icon"><span class="fas fa-cog fa-spin"></span></span>');
	});
});